import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import React from 'react';

import { dateFromAPIToLocalNoon } from '../../../util/dates';
import { FormattedDate, FormattedMessage } from '../../../util/reactIntl';
import { DATE_TYPE_DATE, LINE_ITEM_NIGHT } from '../../../util/types';
import {
  bookingPeriodSectionRightStyles,
  bookingPeriodStyles,
  dayLabelContainerStyles,
  lineItemStyles,
} from './BookingBreakdown.styles';

const BookingPeriod = ({ startDate, endDate, dateType }) => {
  const timeFormatOptions =
    dateType === DATE_TYPE_DATE
      ? {
        weekday: 'long',
      }
      : {
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
      };

  const dateFormatOptions = {
    month: 'short',
    day: 'numeric',
  };

  return (
    <Box sx={bookingPeriodStyles}>
      <Box>
        <Box sx={dayLabelContainerStyles}>
          <Typography variant="lineItemDayLabel">
            <FormattedMessage id="BookingBreakdown.bookingStart" />
          </Typography>
        </Box>
        <Typography variant="lineItemHighlight">
          <FormattedDate value={startDate} {...timeFormatOptions} />
        </Typography>
        <Typography ml={0.5} variant="lineItemLabel">
          <FormattedDate value={startDate} {...dateFormatOptions} />
        </Typography>
      </Box>

      <Box sx={bookingPeriodSectionRightStyles}>
        <Box sx={dayLabelContainerStyles}>
          <Typography variant="lineItemDayLabel">
            <FormattedMessage id="BookingBreakdown.bookingEnd" />
          </Typography>
        </Box>
        <Typography variant="lineItemHighlight">
          <FormattedDate value={endDate} {...timeFormatOptions} />
        </Typography>
        <Typography ml={0.5} variant="lineItemLabel">
          <FormattedDate value={endDate} {...dateFormatOptions} />
        </Typography>
      </Box>
    </Box>
  );
};

const LineItemBookingPeriod = ({ booking, unitType, dateType = null }) => {
  // Attributes: displayStart and displayEnd can be used to differentiate shown time range
  // from actual start and end times used for availability reservation. It can help in situations
  // where there are preparation time needed between bookings.
  // Read more: https://www.sharetribe.com/api-reference/marketplace.html#bookings
  const { start, end, displayStart, displayEnd } = booking.attributes;
  const localStartDate = dateFromAPIToLocalNoon(displayStart || start);
  const localEndDateRaw = dateFromAPIToLocalNoon(displayEnd || end);

  const isNightly = unitType === LINE_ITEM_NIGHT;
  const endDay = isNightly ? localEndDateRaw : moment(localEndDateRaw).subtract(1, 'days');

  return (
    <Box sx={lineItemStyles}>
      <BookingPeriod dateType={dateType} endDate={endDay} startDate={localStartDate} />
    </Box>
  );
};

export default LineItemBookingPeriod;
